export class Store_order_item {
	
	id: string;
	order_id: string;
	quantity: number;
	price: number;
	amount: number;
	order_date: Date;
	item_id: string;
	item_code: string;
	//Not serialized but used in view

	item_name: string;
	quantity_based: boolean;
	amount_based: boolean;

	constructor(values: Object = {}) {
		Object.assign(this, values);
	}


}